// src/utils/factorHelpers.js

/* تبدیل اعداد فارسی به انگلیسی و حذف کاما */
export function parseNum(str) {
  if (str === undefined || str === null) return 0;
  const cleaned = str
    .toString()
    .replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d))
    .replace(/,/g, "")
    .replace(/[^\d.-]/g, "");
  return parseFloat(cleaned) || 0;
}

/* فرمت عدد با جداکننده هزارگان */
export function formatNumber(num) {
  if (num === undefined || num === null || isNaN(num)) return "0";
  const n = Math.round(num);
  return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

/* فرمت عدد فارسی */
export function fmt(n) {
  return Math.round(n || 0).toLocaleString("fa-IR");
}

/* تبدیل عدد به حروف فارسی */
export function numberToPersianWords(num) {
  if (num === undefined || num === null || isNaN(num)) return "";
  num = Math.floor(Number(num));
  if (num === 0) return "صفر";

  const yekan = ["", "یک", "دو", "سه", "چهار", "پنج", "شش", "هفت", "هشت", "نه"];
  const dahgan = [
    "",
    "",
    "بیست",
    "سی",
    "چهل",
    "پنجاه",
    "شصت",
    "هفتاد",
    "هشتاد",
    "نود",
  ];
  const dah = [
    "ده",
    "یازده",
    "دوازده",
    "سیزده",
    "چهارده",
    "پانزده",
    "شانزده",
    "هفده",
    "هجده",
    "نوزده",
  ];
  const sadgan = [
    "",
    "صد",
    "دویست",
    "سیصد",
    "چهارصد",
    "پانصد",
    "ششصد",
    "هفتصد",
    "هشتصد",
    "نهصد",
  ];
  const scales = ["", " هزار", " میلیون", " میلیارد", " بیلیون"];

  function threeDigitToWords(n) {
    const parts = [];
    const sad = Math.floor(n / 100);
    const rem = n % 100;
    if (sad > 0) parts.push(sadgan[sad]);
    if (rem >= 10 && rem < 20) {
      parts.push(dah[rem - 10]);
    } else {
      const dahg = Math.floor(rem / 10);
      const yek = rem % 10;
      if (dahg > 0) parts.push(dahgan[dahg]);
      if (yek > 0) parts.push(yekan[yek]);
    }
    return parts.join(" و ");
  }

  const result = [];
  let scaleIndex = 0;
  while (num > 0) {
    const chunk = num % 1000;
    if (chunk > 0) {
      result.unshift(threeDigitToWords(chunk) + scales[scaleIndex]);
    }
    num = Math.floor(num / 1000);
    scaleIndex++;
  }
  return result.join(" و ");
}

/* ساخت آرایه ارقام برای display */
export function toFaDigits(str, count) {
  const s = str === undefined || str === null ? "" : str.toString();
  const arr = s
    .replace(/[^0-9۰-۹]/g, "")
    .replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d))
    .split("");
  const sliced = arr.slice(0, count);
  while (sliced.length < count) sliced.push("");
  return sliced.map((d) => (d === "" ? "" : "۰۱۲۳۴۵۶۷۸۹"[d]));
}

/* محاسبه جمع‌های فاکتور از آیتم‌ها */
export function calcTotals(items) {
  let sub = 0,
    disc = 0,
    tax = 0,
    lineTotals = [];
  items.forEach((it) => {
    const beforeTax = it.qty * it.price - it.discount;
    const lineTax = it.tax || 0;
    const lineTotal = beforeTax + lineTax;
    sub += it.qty * it.price;
    disc += it.discount;
    tax += lineTax;
    lineTotals.push(lineTotal);
  });
  return { sub, disc, tax, total: sub - disc + tax, lineTotals };
}

/* لیست خالی آیتم */
export function emptyItem() {
  return {
    _key: Math.random().toString(36).slice(2),
    code: "",
    name: "",
    unit: "",
    qty: 1,
    price: 0,
    discount: 0,
    hasTax: false,
  };
}

/* تبدیل میلادی به شمسی */
export function g2j(gy, gm, gd) {
  const g_d_m = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];
  let jy = gy <= 1600 ? 0 : 979;
  gy -= gy <= 1600 ? 621 : 1600;
  const gy2 = gm > 2 ? gy + 1 : gy;
  let days =
    365 * gy +
    Math.floor((gy2 + 3) / 4) -
    Math.floor((gy2 + 99) / 100) +
    Math.floor((gy2 + 399) / 400) -
    80 +
    gd +
    g_d_m[gm - 1];
  jy += 33 * Math.floor(days / 12053);
  days %= 12053;
  jy += 4 * Math.floor(days / 1461);
  days %= 1461;
  if (days > 365) {
    jy += Math.floor((days - 1) / 365);
    days = (days - 1) % 365;
  }
  const jm =
    days < 186 ? 1 + Math.floor(days / 31) : 7 + Math.floor((days - 186) / 30);
  const jd = 1 + (days < 186 ? days % 31 : (days - 186) % 30);
  return { jy, jm, jd };
}

/* تاریخ امروز به فرمت YYYY/MM/DD شمسی */
export function getTodayJalali() {
  const now = new Date();
  const { jy, jm, jd } = g2j(
    now.getFullYear(),
    now.getMonth() + 1,
    now.getDate(),
  );
  const pad = (n) => String(n).padStart(2, "0");
  return `${jy}/${pad(jm)}/${pad(jd)}`;
}
